import _ from 'lodash';
import React from 'react';
import styles from 'styled-components';
import classNames from 'classnames';
import Checkbox from '../../../shared/checkbox';
import {
  FormField,
  HelpBlock,
  Label,
  Row,
} from '../../common/form';
import FundContext from './context';

const SCheckbox = styles(Checkbox)`
  margin-top: 10px;
  margin-left: 0;

  &:hover {
    cursor: pointer;
  }
`;

export default function withNameCheckbox(name, label) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const snake = _.snakeCase(name);

  function CheckboxInput() {
    const { state, dispatch } = React.useContext(FundContext);
    const value = !!state.fund[name];

    const handleChange = () => {
      dispatch({ type: `set${capitalize}`, payload: !value });
    };

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <FormField>
          <SCheckbox
            id={kebab}
            className={classNames('fa fa-border', { 'fa-check': value })}
            onClick={handleChange}
          />
          {state.errors[snake] && <HelpBlock>{state.errors[snake]}</HelpBlock>}
        </FormField>
      </Row>
    );
  }

  CheckboxInput.displayName = capitalize;

  return CheckboxInput;
}
